import './style.less';
import { integrations } from '@prolaera/library';
import { keyBy } from 'lodash';

const oauthUrls = {
  gtwOauth: ({ client_id, redirect_uri }) =>
    `https://api.getgo.com/oauth/v2/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}`
};

export default function($log, $state, $stateParams, $location, ProfileClass, ApiClass, Swal, HelperClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  const integrationsDict = keyBy(integrations, 'id');

  /**
   * Builds and redirects to an oAuth url   */
  vm.getOAuthUrl = () => {
    const redirect_uri = `${$location.protocol()}://${HelperClass.getDomain()}/admin/settings/integrations/${
      $stateParams.type_id
    }`;
    const url = oauthUrls[vm.integration.process]({ ...vm.formData, redirect_uri });
    window.sessionStorage.integrationFormData = JSON.stringify({ ...vm.formData, redirect_uri });
    window.location = url;
  };

  /**
   * Submits integration data either by patch or put, depending on config
   */
  vm.submit = formData => {
    vm.submitButton = true;
    const submit = vm.patch ? ApiClass.companiesIdTypeTypeIdPatch : ApiClass.companiesIdTypePut;
    const { active, ...integration_keys } = formData;
    submit(
      { manage: true, id: company_id, type: 'integrations', type_id: $stateParams.type_id },
      { active, integration_keys, integration_id: $stateParams.type_id }
    )
      .then(() => {
        Swal.toast('Integration information has been saved');
        vm.submitButton = false;
        $state.go('^');
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  /**
   * Gets the details for the integration, then loads it into the form data. If the record doesn't
   * exist, it kicks it over into put mode.
   */
  function _loadIntegration() {
    return ApiClass.companiesIdTypeTypeIdGet({
      manage: true,
      id: company_id,
      type: 'integrations',
      type_id: $stateParams.type_id
    })
      .then(({ data: { item } }) => {
        vm.formData = { ...item.integration_keys, active: item.active };
      })
      .catch(error => {
        if (error.status === 404) {
          vm.patch = false;
          return;
        }
        $log.error(error);
        throw error;
      });
  }

  /**
   * Builds intergration values off query params from redirects   */
  const _setQueryParams = () => {
    const params = $location.search();

    if (Object.keys(params).length) {
      vm.formData = JSON.parse(window.sessionStorage.integrationFormData);
      window.sessionStorage.integrationFormData = false;
      vm.formData = { ...vm.formData, ...params };
      vm.processValiate = true;
    }
  };

  /**
   * Bootstrap function - decides what fields to display based on the state, defaults
   * to a patch state, then calls the function to load the data for that integration
   * from the API.
   */
  function activate() {
    $log.debug('Integration Edit Controller Activated');
    vm.submitButton = false;
    vm.integration = {
      ...integrationsDict[$stateParams.type_id]
    };
    vm.formData = {};
    vm.patch = true;
    _loadIntegration().then(_setQueryParams);
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/integrations/edit/index.js